module.exports = " <div class=vux-checker-item :class=classNames @click=select> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/checker/checker-item.vue
// module id = 209
// module chunks = 2